import React from 'react';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { Intro, Reveal } from './ui';
import { RESEARCH_INDEX, StudyText } from './studies';
import styles from './ScreenInspector.module.css';

/** Dark slide: what the research notebooks measured, number first. Each source links to its study. */
export default function Reliability({ t }) {
    const r = t.reliability;
    return (
        <>
            <Intro eyebrow={r.eyebrow} title={r.title} sub={r.sub} />
            <div className={styles.proof}>
                {r.items.map(([value, text, source], i) => (
                    <Reveal key={value} className={styles.proofItem} delay={0.08 * i}>
                        <p className={styles.proofValue}>{value}</p>
                        <p className={styles.proofText}>{text}</p>
                        <p className={styles.proofSource}><StudyText text={source} /></p>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.55}>
                <p className={styles.proofLimits}>
                    {r.limits}{' '}
                    <a className={styles.studyLink} href={RESEARCH_INDEX} target="_blank" rel="noreferrer">
                        {r.index}
                        <OpenInNewRoundedIcon sx={{ fontSize: 12, ml: 0.3, verticalAlign: '-1px' }} />
                    </a>
                </p>
            </Reveal>
        </>
    );
}
